/**
 * Shows the snackbar.
 *
 * @param {string} text The text to show in the snackbar.
 **/
export default function showSnackbar( text ) {
  const snackbar = document.querySelector( '.js-snackbar' )
  snackbar.innerHTML = text

  snackbar.classList.remove( 'hidden' )
  setTimeout( () => snackbar.classList.remove( 'opacity-0', 'perspective-140' ), 100 )

  setTimeout( () => {
    snackbar.classList.add( 'opacity-0', 'perspective-140', 'hidden' )
  }, 5000 )
}
